export default "__VITE_ASSET__BqPwxp11__"